<div
  class="fixed inset-0 flex justify-end"
  [style.z-index]="zIndex()"
  data-testid="drawer-overlay">
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <div
    class="drawer-backdrop absolute inset-0 bg-zinc-900/70 backdrop-blur-xs dark:bg-black/80"
    data-testid="drawer-backdrop"
    (click)="onBackdropClick()"></div>

  <div
    class="drawer-panel bg-elevated text-text-primary border-default relative flex h-full w-full flex-col border-l shadow-xl"
    [class]="panelClass()"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title()"
    data-testid="drawer-panel">
    <div
      class="drawer-chrome border-weak shrink-0 items-center gap-3 border-b px-4 py-3"
      data-testid="drawer-header">
      @if (config().icon) {
        <i [class]="config().icon" class="text-text-secondary text-lg"></i>
      }

      @if (title()) {
        <h4 class="text-md truncate">{{ title() }}</h4>
      }

      <ng-content select="[drawer-header]" />

      @if (config().dismissible) {
        <app-button
          class="ml-auto"
          (clickEvent)="closeDrawer.emit()"
          aria-label="Close Drawer"
          type="icon"
          data-testid="drawer-close"
          [icon]="ICONS.x" />
      }
    </div>

    <div class="min-h-0 flex-1 overflow-auto" data-testid="drawer-body">
      <ng-content select="[drawer-body]" />
    </div>

    <div
      class="drawer-chrome bg-page border-weak shrink-0 items-center gap-2 border-t px-4 py-2"
      data-testid="drawer-footer">
      <ng-content select="[drawer-footer]" />

      @if (config().actions?.length) {
        <div class="ml-auto flex items-center gap-2">
          @for (action of config().actions; track action.label) {
            <app-button
              size="lg"
              (clickEvent)="action.callback()"
              [type]="action.color"
              [label]="action.label"
              [disabled]="action.disabled ?? false"
              [icon]="action.icon" />
          }
        </div>
      }
    </div>
  </div>
</div>
